import { useTranslation } from "react-i18next";

import { Grid2 } from "@mui/material";

import { CustomSuBAndDescription } from "../../../../../components";
import { IdentityInfo } from "../IdentityInfo/IdentityInfo";
import { TileCard } from "../TileCard/TileCard";
import { useTranslateData } from "./useTranslateData";

export const DigitalIdentity = () => {
  const { t } = useTranslation();
  const mockData = useTranslateData();
  return (
    <>
      <CustomSuBAndDescription
        sub={t("scannerFingerprint.scannerFingerprintTitle")}
        spanSub={t("scannerFingerprint.scannerFingerprintTitleSpan")}
        desc={t("scannerFingerprint.scannerFingerprintDescription")}
      />
      <IdentityInfo />
      <Grid2 container spacing={2.5}>
        {mockData.map(({ title, description, status, icon }, idx) => (
          <Grid2 key={idx} size={{ xs: 12, sm: 6, md: 4 }}>
            <TileCard
              icon={icon}
              title={title}
              description={description}
              status={status}
            />
          </Grid2>
        ))}
      </Grid2>
    </>
  );
};
